// localStorage key 常量定义

// 用户信息存储 key
export const USER_INFO_KEY = 'user'

// Token 存储 key（备用）
export const TOKEN_KEY = 'token'
